import { render, staticRenderFns } from "./ProjectTabOffers.vue?vue&type=template&id=471f70c3&scoped=true"
import script from "./ProjectTabOffers.vue?vue&type=script&lang=ts"
export * from "./ProjectTabOffers.vue?vue&type=script&lang=ts"
import style0 from "./ProjectTabOffers.vue?vue&type=style&index=0&id=471f70c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471f70c3",
  null
  
)

export default component.exports